const iconVariants = {
    regularSelectionSettlementStatus: {
        root: {
            flex: "0 0 auto",
            width: "$s2",
            height: "$s2",
            backgroundColor: "$gray800",
        }
    },
    wonCombination: {
        root: {
            flex: "0 0 auto",
            width: "$s2",
            height: "$s2",
            backgroundColor: "$gray800",
            opacity: 0.6
        }
    },
    regularOpenSelectionSettlementStatus: {
        root: {
            width: "14px",
            height: "14px",
            borderRadius: "100%",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "$gray600",
        }
    },
    nestedSelectionSettlementStatus: {
        $extendFromVariant: "regularSelectionSettlementStatus",
        root: {
            width: "12px",
            height: "12px",
        }
    },
    nestedOpenSelectionSettlementStatus: {
        $extendFromVariant: "regularOpenSelectionSettlementStatus",
        root: {
            width: "10px",
            height: "10px",
        }
    },
    anonymousUser: {
        root: {
            display: "block",
            margin: "0 auto",
            width: "64px",
            height: "64px",
        }
    },
    branding: {
        root: {
            position: "absolute",
            maxWidth: "none !important",
            maxHeight: "none !important",
            bottom: "-58px",
            right: "-64px",
            width: "300px",
            height: "300px",
            color: "#2b2b2b",
            transform: "rotate(-12deg)",
            zIndex: 0,
        }
    },
    noBets: {
        root: {
            display: "block",
            margin: "0 auto",
            width: "64px",
            height: "64px",
        }
    },
    boostInelligible: {
        root: {
            position: "absolute",
            top: "50%",
            left: "8px",
            transform: "translateY(-50%)",
            width: "12px",
            height: "12px",
        }
    }
};
export { iconVariants };
//# sourceMappingURL=icon.js.map